import PasswordRecoverySetPasswordContainer from "./PasswordRecoverySetPasswordContainer";

export default PasswordRecoverySetPasswordContainer;
